import { Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";

interface ProgressBarProps {
  totalSteps: number;
  currentStep: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, currentStep }) => {
  const theme = useTheme();

  const normalizedProgress = (currentStep / totalSteps) * 100;

  return (
    <>
      <Typography align="right" variant="body2" color={theme?.palette?.primary?.dark}>
        {currentStep || 0} de {totalSteps || 0}
      </Typography>
      <LinearProgress variant="determinate" value={normalizedProgress} />
      {/* <BorderLinearProgress variant="determinate" value={normalizedProgress} /> */}
    </>
  );
};
